(() => {
  const V = window.PBVariantV2;
  if (!V || window.PBCustomizerUIV22) return;
  window.PBCustomizerUIV22 = true;

  const q = (r, s) => r?.querySelector(s) || null;
  const qa = (r, s) => r ? [...r.querySelectorAll(s)] : [];
  const n = V.normalize;
  const active = (r, s) => q(r, `${s}.is-active`);
  const data = (r, s, k, d = '') => active(r, s)?.dataset?.[k] || d;
  const parse = (r, s, d) => {
    try { return JSON.parse(q(r, s)?.textContent || JSON.stringify(d)); }
    catch { return d; }
  };
  const money = cents => new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'USD'
  }).format(Number(cents || 0) / 100);

  const boxVar = (variants, color, state) => V.resolveVariant(variants, {
    domain: 'box', state, requiredValues: [color]
  });
  const usbVar = (variants, capacity, state) => V.resolveVariant(variants, {
    domain: 'usb', state, requiredValues: [capacity]
  });

  const setLabel = (button, text) => {
    const span = button?.querySelector(':scope > span');
    if (span) span.textContent = text;
  };

  const ensurePriceWrap = (button, dieNote = false) => {
    if (!button) return null;
    let wrap = q(button, ':scope > .pb-v22-price-wrap');
    if (!wrap) {
      [...button.children].filter(el => el.tagName === 'STRONG').forEach(el => el.remove());
      wrap = document.createElement('span');
      wrap.className = 'pb-v22-price-wrap';
      wrap.innerHTML = '<strong data-pb-v22-price></strong>' +
        (dieNote ? '<small>New logo die: +$30 one-time setup</small>' : '');
      button.appendChild(wrap);
    }
    return q(wrap, '[data-pb-v22-price]');
  };

  const setDelta = (button, paid, base, fallback = '') => {
    const price = ensurePriceWrap(button, button?.dataset?.pbLogo === 'box' || button?.dataset?.pbLogo === 'addon');
    if (!price) return;
    if (paid && base) {
      const difference = Math.max(Number(paid.price || 0) - Number(base.price || 0), 0);
      price.textContent = `+${money(difference)}${button?.dataset?.pbLogo === 'box' || button?.dataset?.pbLogo === 'addon' ? ' each*' : ''}`;
      return;
    }
    price.textContent = fallback;
  };

  const ensureLogoButton = (group, kind, label, dieNote = false) => {
    let button = q(group, `[data-pb-logo="${kind}"]`);
    if (!button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'pb-photo-customizer__choice';
      button.dataset.pbLogo = kind;
      button.innerHTML = `<span>${label}</span>`;
      group.appendChild(button);
    }
    button.hidden = false;
    setLabel(button, label);
    ensurePriceWrap(button, dieNote);
    return button;
  };

  const family = root => (q(root, '.pb-photo-customizer__header h2')?.textContent || '')
    .replace(/^Customize your\s+/i, '').trim();

  const isPhotoUSBFamily = fam => {
    const f = n(fam);
    return f.includes('photo') && f.includes('usb');
  };

  const blankLabel = fam => {
    const f = n(fam);
    if (isPhotoUSBFamily(fam)) return 'Blank Photo + USB Box — No Personalization';
    if (f.includes('usb box')) return 'Blank USB Box — No Personalization';
    return 'Blank Box — No Personalization';
  };

  const currentColor = root => data(root, '[data-color]', 'color', 'Cream');
  const currentCapacity = root => data(root, '[data-usb-capacity]', 'usbCapacity', '8GB');

  const directBox = (root, variants) => {
    const group = q(root, '[data-pb-personalization]');
    if (!group) return;
    const standard = q(group, '[data-personalization="standard"]');
    const text = q(group, '[data-personalization="personalized"]');
    const fam = family(root);

    setLabel(standard, blankLabel(fam));
    setLabel(text, 'Add Foil Text');
    ensurePriceWrap(text, false);
    const logo = ensureLogoButton(group, 'box', 'Add Foil Logo', true);

    const card = group.closest('.pb-photo-customizer__card');
    if (card) {
      const heading = q(card, 'h3');
      const copy = q(card, 'p');
      if (heading) heading.textContent = `Personalize your ${fam}?`;
      if (copy) copy.textContent = `Choose a blank ${fam}, add custom foil text, or upload your logo for custom foil stamping.`;
    }

    const intro = q(root, '.pb-photo-customizer__intro p');
    if (intro) {
      if (isPhotoUSBFamily(fam)) {
        intro.textContent = 'Choose your linen color, personalize your photo + USB box with foil text or a foil logo, then optionally add and personalize a compatible USB drive.';
      } else if (n(fam).includes('usb box')) {
        intro.textContent = 'Choose your linen color, personalize your USB box with foil text or a foil logo, then optionally add and personalize a USB drive.';
      } else {
        intro.textContent = 'Choose your linen color, then leave your box blank or add foil text or a foil logo before adding to cart.';
      }
    }

    const update = () => {
      const color = currentColor(root);
      const blank = boxVar(variants, color, 'blank');
      setDelta(text, boxVar(variants, color, 'text'), blank, '');
      setDelta(logo, boxVar(variants, color, 'logo'), blank, '+$7.00 each*');
    };
    ['click', 'change'].forEach(event => root.addEventListener(event, () => setTimeout(update, 0)));
    update();
  };

  const usbChoices = (root, productGetter) => {
    const group = q(root, '[data-pb-usb-engraving]');
    if (!group) return;
    const none = q(group, '[data-usb-engraving="no"]');
    const text = q(group, '[data-usb-engraving="yes"]');
    setLabel(none, 'No Engraving');
    setLabel(text, 'Add Text Engraving');
    ensurePriceWrap(text, false);
    const logo = ensureLogoButton(group, 'usb', 'Add Logo Engraving', false);

    const section = group.closest('.pb-usb-addon__section, .pb-photo-customizer__card');
    if (section) {
      const heading = q(section, 'h3, h4');
      const copy = q(section, 'p');
      if (heading) heading.textContent = 'Personalize your USB?';
      if (copy) copy.textContent = 'Leave your USB unengraved, add text engraving, or upload a logo for engraving.';
    }

    const engravingColorLabel = qa(root, 'label').find(label => n(label.textContent).includes('engraving color'));
    const engravingColorCopy = engravingColorLabel?.parentElement?.querySelector('p, small') || null;

    const update = () => {
      const product = productGetter();
      const variants = product?.variants || [];
      const capacity = currentCapacity(root);
      const base = usbVar(variants, capacity, 'none');
      setDelta(logo, usbVar(variants, capacity, 'logo'), base, 'Variant not set');

      if (engravingColorCopy && product?.type) {
        if (n(product.type).includes('wood')) {
          engravingColorCopy.textContent = 'Wood USB engraving appears dark brown for a natural, high-contrast finish.';
        } else {
          engravingColorCopy.textContent = 'Crystal USB engraving is finished in white for strong contrast and visibility.';
        }
      }
    };
    ['click', 'change'].forEach(event => root.addEventListener(event, () => setTimeout(update, 0)));
    update();
  };

  const addonBox = (root, products) => {
    const group = q(root, '[data-pb-box-personalization]');
    if (!group) return;
    const standard = q(group, '[data-box-personalization="standard"]');
    const text = q(group, '[data-box-personalization="personalized"]');
    setLabel(standard, 'Blank Box');
    setLabel(text, 'Add Foil Text');
    ensurePriceWrap(text, false);
    const logo = ensureLogoButton(group, 'addon', 'Add Foil Logo', true);

    const label = group.closest('.pb-photo-customizer__field')?.querySelector('label');
    if (label) label.textContent = 'Personalize your presentation box?';

    const update = () => {
      const key = data(root, '[data-box-key]', 'boxKey');
      const color = data(root, '[data-box-color]', 'boxColor');
      const variants = products[key]?.variants || [];
      const blank = boxVar(variants, color, 'blank');
      setDelta(text, boxVar(variants, color, 'text'), blank, '');
      setDelta(logo, boxVar(variants, color, 'logo'), blank, '+$7.00 each*');
    };
    ['click', 'change'].forEach(event => root.addEventListener(event, () => setTimeout(update, 0)));
    update();
  };

  if (!document.getElementById('pb-v22-style')) {
    const style = document.createElement('style');
    style.id = 'pb-v22-style';
    style.textContent = `
      .pb-v22-price-wrap{margin-left:auto;display:flex;flex-direction:column;align-items:flex-end;gap:.15rem;text-align:right;line-height:1.15}
      .pb-v22-price-wrap strong{font-size:.9em}.pb-v22-price-wrap small{font-size:1.05rem;font-weight:400;opacity:.68;max-width:18rem}
      @media(max-width:549px){.pb-v22-price-wrap small{max-width:14rem}}
    `;
    document.head.appendChild(style);
  }

  qa(document, '[id^="PBPhotoBoxCustomizer-"]').forEach(root => {
    directBox(root, parse(root, '[data-pb-variants-json]', []));
  });

  qa(document, '[id^="PBUSBBoxCustomizer-"]').forEach(root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const products = parse(root, '[data-pb-usb-products-json]', {});
    directBox(root, variants);
    usbChoices(root, () => products[data(root, '[data-usb-key]', 'usbKey')]);
  });

  qa(document, '[id^="PBStandaloneUSBCustomizer-"]').forEach(root => {
    const variants = parse(root, '[data-pb-variants-json]', []);
    const products = parse(root, '[data-pb-box-products-json]', {});
    const intro = q(root, '.pb-photo-customizer__intro p');
    if (intro) intro.textContent = 'Choose your storage capacity, then leave your USB unengraved or add text or logo engraving. You can also add a presentation box.';
    usbChoices(root, () => ({ variants }));
    addonBox(root, products);
  });
})();
